import Box from 'UIKit/Box/Box'
import { BoxProps } from 'UIKit/Box/types'

import { BIG_ZERO } from 'config/constants/number'
import { useState } from 'react'
import styled from 'styled-components'
import { ModalColorTheme } from 'theme/modal/colors'
import AlchemyModal, { ModalBody, ModalHeader, ModalProps } from 'UIKit/AlchemyModal'
import HistoryTable from './components/HistoryTable'
import HUSDClaim from './components/HUSDClaim'

interface HUSDUnlockProps {}

const HUSDUnlock: React.FC<ModalProps<HUSDUnlockProps & BoxProps>> = ({ onDismiss, ...props }) => {
  const [totalClaimed, setTotalClaimed] = useState(BIG_ZERO)

  return (
    <StyledModal onDismiss={onDismiss} colorTheme={ModalColorTheme.Darkblue} {...props}>
      <ModalHeader colorTheme={ModalColorTheme.Darkblue} title="HUSD Rakeback" />

      <ModalBody py="0px !important">
        <Box>
          <StyledUnlockInfoContainer padding={['24px', '', '24px 32px']}>
            <HUSDClaim setTotalHUSDClaimed={setTotalClaimed} />
          </StyledUnlockInfoContainer>

          <StyledTableContainer padding={['24px', '', '24px 32px']} mt="8px" borderRadius="16px">
            <HistoryTable totalClaimed={totalClaimed} />
          </StyledTableContainer>
        </Box>
      </ModalBody>
    </StyledModal>
  )
}

const StyledModal = styled(AlchemyModal)`
  padding-bottom: 20px;

  ${({ theme: { mediaQueries } }) => mediaQueries.sm} {
    min-width: 420px;
    max-width: 420px;
    min-height: 576px;
  }
`

const StyledTableContainer = styled(Box)`
  background-color: ${({ theme }) => theme.modal.colors[ModalColorTheme.Darkblue].modalCard};
`

const StyledUnlockInfoContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
  width: 100%;
  background-color: ${({ theme }) => theme.modal.colors[ModalColorTheme.Darkblue].modalCard};
  border-radius: ${({ theme }) => theme.radii.modal};
`

export default HUSDUnlock
